@if (shouldShow) {
    <ui-dialog
        header="benefits.benefitsPayroll.unmappedEmployeesFromTheStatement"
        [open]="mappingDialogOpen"
        [primaryButtonLabel]="'close' | translate"
        (closing)="mappingDialogOpen = false"
        (primaryButtonPressed)="mappingDialogOpen = false"
    >
        <p class="explainer">
            {{ 'benefits.benefitsPayroll.pleaseMapTheEmployeesFromTheBenefitsStatement' | translate }}
        </p>

        <div class="unmapped-employees">
            <div class="row">
                <div>
                    {{ 'benefits.benefitsPayroll.unmappedEmployees' | translate }}
                </div>

                <div>
                    {{ 'benefits.benefitsPayroll.employeesUniqueIdentifier' | translate }}
                </div>

                <div>
                    {{ 'benefits.benefitsPayroll.selectEmployeeInHumi' | translate }}
                </div>
            </div>
            @for (unmappedEmployee of unmappedEmployees; track unmappedEmployee) {
                <div class="row">
                    <div class="align-self-center">{{ unmappedEmployee.attributes.employeeName }}</div>
                    <div class="align-self-center">{{ unmappedEmployee.attributes.certificateNumber }}</div>
                    <div>
                        <ng-container
                            [ngTemplateOutlet]="employeeSelectionOptions"
                            [ngTemplateOutletContext]="{
                                certificateNumber: unmappedEmployee.attributes.certificateNumber,
                            }"
                        />
                    </div>
                </div>
            }
        </div>
        <ng-template #employeeSelectionOptions let-certificateNumber="certificateNumber">
            <mat-form-field class="employee-selection">
                <mat-select
                    placeholder="{{ 'benefits.benefitsPayroll.selectAnEmployee' | translate }}"
                    (selectionChange)="associateToEmployee(certificateNumber, $event.value)"
                >
                    <mat-option [value]="null">{{ 'benefits.benefitsPayroll.none' | translate }}</mat-option>

                    @for (employeeChoice of employeeChoices?.values(); track employeeChoice) {
                        <mat-option [value]="employeeChoice" [disabled]="employeeChoice.disabled"
                            >{{ employeeChoice.employeeBenefitPlan.simpleEmployee.account.fullName }} ({{
                                employeeChoice.employeeBenefitPlan.simpleEmployee.firstName
                            }})</mat-option
                        >
                    }
                </mat-select>
            </mat-form-field>
        </ng-template>
    </ui-dialog>

    <ui-banner [variant]="bannerVariant" [showIcon]="!isLoading">
        @if (isLoading) {
            <mat-progress-spinner mode="indeterminate" diameter="20" />
        }

        {{ bannerMessage | translate }}

        @if (!isLoading && unmappedEmployees.length) {
            <ui-button type="outline" size="compact" class="margin-left-auto" (click)="mappingDialogOpen = true">
                {{ 'benefits.benefitsPayroll.view' | translate }}
            </ui-button>
        }
    </ui-banner>
}
